import { render, staticRenderFns } from "./AdminBookingClashes.vue?vue&type=template&id=65ab5395"
import script from "./AdminBookingClashes.vue?vue&type=script&lang=js"
export * from "./AdminBookingClashes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports